import { HttpInterceptor } from "@angular/common/http";
import { Type } from "@angular/core";

import {
    CreateUserSessionOn401UnauthorizedInterceptor,
    RedirectOn404NotFoundInterceptor,
    RedirectOn410GoneInterceptor,
} from "@hermes/core-interceptors";

import { APP_CHILD_ROUTES } from "./app-child.routes";

type Path = (typeof APP_CHILD_ROUTES)[number]["path"];

export const APP_ROUTE_INTERCEPTORS: Record<
    Path,
    Array<Type<HttpInterceptor>>
> = {
    "404-error": [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    "": [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    "environment/": [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    legal: [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    "empty-page": [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    "test-page/": [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    "personalization-landing-page": [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    "500-error": [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    "**": [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    category: [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    "search/": [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    "product/:productCategory/config/:slug/": [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    product: [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn410GoneInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    "cart/": [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    "login/": [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    "checkout/login/": [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    "account/create/": [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    "checkout/": [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    "contact-us/": [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    "order/:orderId/": [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    "payment-validation": [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    "find-store/:country/:city/:id/": [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    "find-store/:country/:city/:id/appointment/": [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    "find-store": [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    content: [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    aftersales: [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    "care-and-use/": [
        CreateUserSessionOn401UnauthorizedInterceptor,
        RedirectOn404NotFoundInterceptor,
    ],
    // eslint-enable @typescript-eslint/naming-convention
};
